"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.array.concat.js");

var _constants = require("../constants");

var _commonComponents = require("../commonComponents");

var _react = _interopRequireDefault(require("react"));

var _responsiveTable = require("./responsiveTable");

var _lodash = _interopRequireDefault(require("lodash"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var Th = (0, _styledComponents["default"])(_responsiveTable.Th).withConfig({
  displayName: "tabularHeading__Th"
})(["padding-left:0 !important;padding-right:0 !important;padding-bottom:0 !important;"]);
var rangeTypes = {
  range_0to10: _constants.range_0to10,
  range_0to5: _constants.range_0to5,
  range_1to10: _constants.range_1to10
};

var _default = function _default(inputs, displayHeading) {
  return _lodash["default"].map(inputs, function (input, fieldIndex) {
    var component = input.component.toLowerCase();
    var style = _lodash["default"].has(input.config, "style") ? input.config.style : {};

    if (fieldIndex === 0) {
      // no heading for the first element, assuming it's the heading
      return /*#__PURE__*/_react["default"].createElement(Th, {
        style: style,
        key: "".concat(input.label, "_").concat(fieldIndex)
      }, input.required && "* ", displayHeading && input.label);
    }

    switch (component) {
      case "range_1to10":
      case "range_0to10":
      case "range_0to5":
        var ListOfOptions = rangeTypes[component];
        return /*#__PURE__*/_react["default"].createElement(Th, {
          key: "".concat(input.label, "_").concat(fieldIndex)
        }, /*#__PURE__*/_react["default"].createElement(_commonComponents.RangeHeaderContainer, null, _lodash["default"].map(ListOfOptions, function (value, key) {
          if (_lodash["default"].isPlainObject(value)) {
            return /*#__PURE__*/_react["default"].createElement("li", {
              style: style,
              key: "".concat(value.label, "_").concat(fieldIndex)
            }, input.required && "* ", value.label);
          } else {
            return /*#__PURE__*/_react["default"].createElement("li", {
              style: style,
              key: "".concat(value, "_").concat(fieldIndex, "_").concat(key)
            }, input.required && "* ", value);
          }
        })));

      case "radioinput":
        // checking to see if the input field is a "built in" range type
        // as a convenience we build in 0-10, 1-10, 0-5 ranges to make configuration
        // a little bit easier through study manager
        return /*#__PURE__*/_react["default"].createElement(Th, {
          key: "".concat(input.label, "_").concat(fieldIndex)
        }, /*#__PURE__*/_react["default"].createElement(_commonComponents.RangeHeaderContainer, null, _lodash["default"].map(input.options, function (value, key) {
          return /*#__PURE__*/_react["default"].createElement("li", {
            style: style,
            key: "".concat(value.label, "_").concat(fieldIndex, "_").concat(key)
          }, input.required && "* ", value.label);
        })));

      default:
        return /*#__PURE__*/_react["default"].createElement(Th, {
          style: style,
          key: "".concat(input.label, "_").concat(fieldIndex)
        }, input.required && "* ", input.label);
    }
  });
};

exports["default"] = _default;